"use client";

import type { FeedItem } from "../../../../types/content/feedItem";

import { isInjectable } from "../../../../utils/typechecks";
import { TeaserCluster } from "../../../TeaserCluster/TeaserCluster";
import { FeedItemToTeaser } from "../../utils/feedItemToTeaser";

const CategoryArticlesList = ({
  feedItem,
  positionInFeed,
}: {
  feedItem: FeedItem;
  positionInFeed: number;
}) => {
  if (isInjectable(feedItem)) {
    return null;
  }

  let currentNrOfClusters = 0;

  currentNrOfClusters++;
  return (
    <TeaserCluster
      style={feedItem.style}
      header={feedItem.header}
      footer={feedItem.footer}
      key={`${feedItem.id} ${positionInFeed}`}
      isSmallCluster={feedItem.type === "Single"}
      teaserWeightValue={feedItem.weight}
    >
      <FeedItemToTeaser
        feedItem={feedItem}
        positionInFeed={positionInFeed}
        currentNrOfClusters={currentNrOfClusters}
      />
    </TeaserCluster>
  );
};

export { CategoryArticlesList };
